import React from 'react'

export default function PageNotFound() {
    return (
        <div style={{ minHeight: "200px", textAlign: "center", paddingTop: "100px" }}>
            <h4>Page Not Found Oops!!!......</h4>
        </div>
    )
}
